/* eslint-disable react/no-unused-state */
/* eslint-disable react/jsx-closing-tag-location */
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import StepperHeading from '../../Common/StepperHeading';

import Session from '../../../Service/Session';
import OtherInfoForm from '../../Common/SharedSlideInput/OtherInfo';
import { withTranslation } from 'react-i18next';
import { removeCountryCode, getCountryCode } from '../../../AppUtil/AppUtil';

const styles = theme => ({
	formControl: {
		margin: theme.spacing(1),
		minWidth: 250
	}
});

class index extends Component {
	// NOSONAR

	constructor(props) {
		super(props);
		this.inputLabel = React.createRef();
		this.state = {
			name: '',
			relationship: '',
			emailId: '',
			phone: '',
			countryCode: '+63'
		};
	}

	setDefaultValue = () => {
		const loanObject = Session.get('LOAN_OBJECT');
		if (loanObject.id) {
			this.props.openScreen('VIEW_SUMMARY');
			return;
		}
		if (!loanObject.other_info) {
			return;
		}
		const otherInfo = loanObject.other_info;
		this.setState({
			name: otherInfo.name,
			emailId: otherInfo.emailId,
			phone: otherInfo.phone,
			relationship: otherInfo.relationship,
			countryCode: otherInfo.countryCode
		});
	};

	/**
	 * This function handle submit login form
	 * @returns {Promise<void>}
	 */

	slicePhoneNumber = phone => {
		return phone.charAt(1) === '1' ? phone.slice(2) : phone.slice(3);
	};

	setDefaultValueWhenFromDetails = () => {
		const userInfo = this.props.userDetails.accepted_by_user;
		this.setState({
			emailId: userInfo.email ? userInfo.email : '',
			name: userInfo.name,
			relationship: this.props.userDetails.relationship,
			countryCode: userInfo.phone ? getCountryCode(userInfo.phone) : '+63',
			phone: userInfo.phone ? removeCountryCode(userInfo.phone) : ''
		});
	};

	componentDidMount() {
		if (this.props.fromDetails) {
			this.setDefaultValueWhenFromDetails();
		}
	}

	render() {
		const { t } = this.props;
		
		return (
			<OtherInfoForm
				flow={this.props.flow}
				fromDetails={this.props.fromDetails}
				handleBack={this.props.fromDetails ? this.props.backToDetail : this.props.handleBack}
				heading={
					<StepperHeading
						text={
							this.props.flow === 'LEND'
								? t('work_flows.who_is_the_borrower')
								: t('work_flows.who_do_you_want_to_borrow_from')
						}
					/>
				}
				initOtherInfo={this.state}
				onContinue={() => {
					/* */
				}}
				onSubmitDetail={
					this.props.fromDetails
						? this.props.onSubmitDetail
						: () => {
								/* */
						  }
				}
				supportedRelationships={this.props.supportedRelationships}
				userDetails={this.props.fromDetails ? this.props.userDetails : null}
			/>
		);
	}
}

export default withTranslation(['Core'])(withStyles(styles)(index));
